<template>
  <div class="msg" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <h3 style="margin: 0; background-color: #666; padding: 3px; color: #fff; font-weight: 600;">群發廣播</h3>
    <div v-if="broadcastData.Service === 'LINE'">
      <hr/>
      <div style="padding: 5px;">
        <el-row>
          <el-col :span="12">
            <div class="work">會員總數: <span v-if="!memberNum && memberNum === ''">---</span><span v-else>{{ memberNum }}</span></div>
          </el-col>
          <el-col :span="12">
            <div class="work">分眾會員數: <span v-if="!tagNums && tagNums === ''">---</span><span v-else>{{ tagNums }}</span></div>
          </el-col>
        </el-row>
      </div><hr/>
      <el-radio-group v-model="radio" @change="changeCardGroup" style="margin-top: 5px;">
        <el-radio-button label="全部" style="margin-bottom: 10px"></el-radio-button>
        <el-radio-button label="文字訊息"></el-radio-button>
        <el-radio-button label="圖片訊息"></el-radio-button>
        <el-radio-button label="圖片卡片"></el-radio-button>
        <el-radio-button label="文字卡片"></el-radio-button>
        <el-radio-button label="橫向卡片"></el-radio-button>
        <el-radio-button label="直向卡片"></el-radio-button>
        <el-radio-button label="語音訊息"></el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="broadcastData.Service === 'FB'"><hr/>
      <div style="padding: 5px;">
        <el-row>
          <el-col :span="8">
            <div class="work">可用廣播點數: {{ allSub }}</div>
          </el-col>
          <el-col :span="8">
            <div class="work">會員總數: <span v-if="!memberNum && memberNum === ''">---</span><span v-else>{{ memberNum }}</span></div>
          </el-col>
          <el-col :span="8">
            <div class="work">分眾會員數: <span v-if="!tagNums && tagNums === ''">---</span><span v-else>{{ tagNums }}</span></div>
          </el-col>
        </el-row>
      </div><hr/>
      <el-radio-group v-model="radio" @change="changeCardGroup" style="margin-top: 5px;">
        <el-radio-button label="全部" style="margin-bottom: 10px"></el-radio-button>
        <el-radio-button label="文字訊息"></el-radio-button>
        <el-radio-button label="圖片訊息"></el-radio-button>
        <el-radio-button label="文字卡片"></el-radio-button>
        <el-radio-button label="網頁卡片"></el-radio-button>
        <el-radio-button label="橫向卡片"></el-radio-button>
        <el-radio-button label="直向卡片"></el-radio-button>
        <el-radio-button label="語音訊息"></el-radio-button>
      </el-radio-group>
    </div>
    <!-- 下拉選單 -->
    <div id="selectCard">
      <div style="margin-bottom: 5px;">
        <el-row>
          <!-- 選擇卡片 -->
          <el-col :span="12">
            <div class="selector">
              <el-select v-model="broadcastData.CardValue" placeholder="選擇卡片" style="width: 100%;" no-data-text="尚無卡片">
                <el-option v-for="item in cardTable2"
                  :key="item.name"
                  :label="item.name"
                  :value="JSON.stringify(item)">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <!-- 選擇分眾 -->
          <el-col :span="12">
            <div class="selector">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-select v-model="radio1" placeholder="請選擇" style="width: 100%;" @change="broadcastData.Tag = ''">
                    <el-option v-for="item in ['生日標籤', '特定標籤']"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="broadcastData.Tag" placeholder="選擇分眾" style="width: 100%;" @change="getTagNum">
                    <el-option v-for="item in getList(userTagsBox)" :key="item" :label="item" :value="(item === '無') ? null : item"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding: 5px 5px 10px 5px; border: 1px solid #eee; margin-top: 10px;">
        <div style="font-size: 18px;">藍色選單 ( 若還未設定請先前往<span style="color: #f24">卡片管理區</span> )</div>
        <div style="margin-top: 10px;">
          <mu-select v-model="broadcastData.Reply"
            @change="searchMenu"
            style="width: 240px;"
            hintText="請選擇選單"
            v-if="toggle">
            <mu-option v-for="(item, index) in blueMenu"
              :key="index + 'b'"
              :value="item"
              :label="item"/>
          </mu-select>
          <mu-switch v-model="toggle" label="自訂選單" class="demo-switch" style="margin-left: 10px;"/><hr style="margin: 7px;"/>
          <div style="margin-top: 10px; font-size: 18px; line-height: 30px; padding-top: 5px;">
            <div v-for="(item, index) in blueMenuDatas"
              style="margin-bottom: 10px;"
              :key="index + 'm'"
              :index="index"
              class="blue_btn">{{item}}
            </div>
          </div>
          <div style="margin-top: 10px; color: #777;">( 如果沒有自訂選單會預設為 "公版主選單" )</div>
        </div>
      </div>
    </div>
    <!-- 選擇時間 -->
    <div v-if="broadcastType === '排程'" style="border: 1px solid #eee;">
      <el-row>
        <el-col :span="5" style="border-right: 1px solid #eee; line-height: 57px; font-size: 16px; background-color: #fccca9; color: #444;">
          <div>發佈時間</div>
        </el-col>
        <el-col :span="19" style="line-height: 55px; font-size: 18px; text-align: left; padding-left: 20px;">
          <el-date-picker v-model="broadcastData.scheduleTime"
            style="width: 70%"
            type="datetime"
            placeholder="選擇排程時間"
            align="right"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <!-- 送出廣播 -->
    <div style="padding-top: 15px;">
      <el-button type="danger" style="width: 100%;" @click="checkBroadcast">立即送出</el-button>
    </div>
    <mu-dialog :open="finalCheck" title="再次確認" width="550">
      <div v-if="broadcastType === '群發'">
        <span v-if="broadcastData.Service === 'FB'">確定要發送這則廣播嗎? 此次廣播後將剩餘: {{ allSub - (parseInt(tagNum) * broadcastData.CardID.length) }} 點</span>
        <span v-else>確定要發送這則廣播嗎?</span>
      </div>
      <div v-if="broadcastType === '排程'">
        <span v-if="broadcastData.Service === 'FB'">確定要排程這則廣播嗎? 廣播發送後將剩餘: {{ allSub - (parseInt(tagNum) * broadcastData.CardID.length) }} 點</span>
        <span v-else>確定要排程這則廣播嗎?</span>
      </div>
      <mu-button slot="actions" flat color="primary" @click="finalCheck = false">返回</mu-button>
      <mu-button slot="actions" color="primary" @click="sendBroadcast">確認</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';


export default {
  name: 'broadcast',
  data() {
    return {
      radio: '全部',
      toggle: false,
      finalCheck: false,
      cardTable2: [],
      tagNums: '',
      blueMenuDatas: [],
      radio1: '特定標籤',
      broadcastData: {
        Service: this.$route.params.service,
        Auth: this.$route.params.id,
        CardValue: '',
        CardID: [],
        CardName: '',
        Tag: null,
        Reply: '公版主選單',
        scheduleTime: ''
      },
      pageLoading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    }
  },
  props: ['cardTable', 'memberNum', 'tagNum', 'userTagsBox', 'blueMenu', 'broadcastType', 'blueMenuData', 'allSub', 'TagList'],
  mounted() {
    this.tagNums = this.tagNum;
    this.blueMenuDatas = this.blueMenuData;
    this.cardTable2 = this.cardTable;
  },
  computed: {
    ...mapGetters({
      menus: 'menus',
      workFlows: 'workFlows'
    })
  },
  methods: {
    ...mapActions({
      getBlueMenuBeta   : 'getBlueMenuBeta',
      scheduleBroadcast : 'scheduleBroadcast',
      queryMenuLINE     : 'queryMenuLINE',
      broadcast         : 'broadcast',
    }),
    changeCardGroup() {
      this.broadcastData.CardValue = '';
      if (this.radio === '全部') {
        this.cardTable2 = this.cardTable;
      }
      else {
        this.cardTable2 = this.cardTable.filter(el => el.type === this.radio);
      }
    },
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    showErrorMessage(message, time) {
      this.$notify({
        title: message,
        type: 'error'
      });
    },
    getList(list) {
      if (this.radio1 === '生日標籤') {
        return list.filter(el => el.indexOf('ELS_BIRTH') !== -1);
      }
      else {
        return list.filter(el => el.indexOf('ELS_BIRTH') === -1);
      }
    },
    getTagNum(val) {
      const selectedTag = this.TagList.filter(el => el[0] === val)[0];
      if (selectedTag) {
        this.tagNums = selectedTag[1].totalRecipients;
      }
      else {
        this.tagNums = this.memberNum;
      }
    },
    searchMenu() {
      const auth  = this.broadcastData.Auth;
      const reply = this.broadcastData.Reply;
      // 判斷平台
      if (this.broadcastData.Service === 'FB') {
        if (this.menus[auth]) {
          const menuData = reply ? this.menus[auth][reply] : this.menus[auth]['公版主選單'];
          this.blueMenuDatas = menuData.edit.Menu;
        }
        else {
          this.getBlueMenuBeta(auth).then(() => {
            const menuData = reply ? this.menus[auth][reply] : this.menus[auth]['公版主選單'];
            this.blueMenuDatas = menuData.edit.Menu;
          })
        }
      }
      else {
        const selectedMenu = reply ? reply : '公版主選單';
        if (this.menus[auth]) {
          this.blueMenuDatas = Object.values(this.menus[auth][selectedMenu].quickReply.items).map(el => el.action.text);
        }
        else {
          this.queryMenuLINE(auth).then(() => {
            this.blueMenuDatas = Object.values(this.menus[auth][selectedMenu].quickReply.items).map(el => el.action.text);
          })
        }
      }
    },
    sendBroadcast() {
      this.pageLoading = true;
      this.finalCheck = false;
      if (this.broadcastType === '群發') {
        this.broadcast(this.broadcastData).then(() => {
          this.pageLoading = false;
          // this.$emit('getBroadcastRecord', '');
          this.showFlassMessage('正在發送廣播', 2000);
        })
      }
      else {
        this.scheduleBroadcast(this.broadcastData).then(() => {
          this.pageLoading = false;
          // this.$emit('getScheduleRecord', '');
          this.showFlassMessage('已排程一則廣播', 2000);
        })
      }
    },
    checkBroadcast() {
      if (!this.broadcastData.CardValue || this.broadcastData.CardValue === '') {
        this.showErrorMessage('尚未選擇卡片哦!', 2000);
        return;
      }
      const cardName = JSON.parse(this.broadcastData.CardValue).name;
      const cardID = JSON.parse(this.broadcastData.CardValue).cards;
      this.broadcastData.CardID = cardID;
      this.broadcastData.CardName = cardName;
      if (this.broadcastData.Service === 'FB' && this.allSub < (parseInt(this.tagNums) * cardID.length)) {
        this.showErrorMessage('目前點數不足哦!', 2000);
        return;
      }
      if (this.broadcastType === '排程') {
        if (!this.broadcastData.scheduleTime && this.broadcastData.scheduleTime === '') {
          this.showErrorMessage('還未選擇排程時間哦!', 2000);
          return;
        }
        else {
          const selectedTime = new Date(this.broadcastData.scheduleTime).getTime();
          if (selectedTime - Date.now() < 300000) {
            this.showErrorMessage('排程時間至少要5分鐘後哦!', 2000);
            return;
          }
          else {
            this.broadcastData.scheduleTime = selectedTime;
          }
        }
      }
      this.finalCheck = true;
    }
  },
}
</script>

<style scoped>
.textarea {
  text-align: left;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  border-radius: 7px;
}
.selector {
  border: 1px solid #888;
  padding: 15px 11px;
}
.blue_btn {
  background: rgba(48, 117, 229, 0.2);
  border: 1px solid rgba(48, 117, 229, 1);
  color: rgba(48, 117, 229, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.blue_btn:hover {
  background: rgba(255, 28, 28, 0.2);
  border: 1px solid rgba(255, 28, 28, 1);
  color: rgba(255, 28, 28, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  min-width: 750px;
  max-width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.work {
  font-size: 17px;
}
.layout {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0!important;
  flex: 1 1 100%;
  padding: 30px;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
</style>